import { UTILITY_USER_ROLE_SALES_REP } from 'common/utility/userRoles';

import { SR_API_ACTION_UTILITY_USER_GET_LIST_WITH_ROLE } from 'api/utilityActionTypes';

export default async function getSalesRepList(
  { state, utilityApiClient },
  { forceRefresh = false } = {},
) {
  const currentStatePath = ['utilitySalesReps', 'list'];
  if (!forceRefresh && state.get(currentStatePath)) {
    return state.get(currentStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_USER_GET_LIST_WITH_ROLE,
    state: state,
    queryId: UTILITY_USER_ROLE_SALES_REP,
    payload: {
      role: UTILITY_USER_ROLE_SALES_REP,
    },
    onSuccess(salesReps) {
      if (salesReps) {
        state.set(currentStatePath, salesReps);
      }
    },
  });
}
